import { telUrl } from '@shared/maps';
import { glossInline } from '@shared/ptEn';
import { Bilingual } from '@/components/Bilingual';

export function EmergencyPage() {
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Emergency</h1>
        <p className="page-subtitle">Portugal — 112 first</p>
      </div>
      <div className="card">
        <a className="action-btn action-btn--urgent" href={telUrl('112')}>
          Call 112
        </a>
        <p style={{ marginTop: 12 }}>
          {glossInline(
            '112 reaches police, ambulance, and fire. English is usually available. The nearest ER is Hospital de Portimão.',
          )}
        </p>
        <div className="action-row">
          <a className="action-btn" href={telUrl('+351282450300')}>
            <Bilingual text="Hospital Portimão" />
          </a>
          <a className="action-btn" href={telUrl('+351282350370')}>
            Rocha Brava reception
          </a>
        </div>
      </div>
    </div>
  );
}
